import { render, staticRenderFns } from "./LanguageInput.vue?vue&type=template&id=4f776ad2&"
import script from "./LanguageInput.vue?vue&type=script&lang=js&"
export * from "./LanguageInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LanguageInput.vue"
export default component.exports